
const namespaced = true

const state = {
	token:'',
    positions: []
}

const getters = {

}

const mutations = {
	token (state, token) {
        state.token = token
        localStorage.setItem('token', token)
    },
    position (state, payload) {
        state.positions[payload.name] = payload.position
    }
}

const actions = {
    setToken({ commit, dispatch, state }, token) {
        commit('token', token)
        axios.defaults.headers.common = {
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': `Bearer ${token}`
        }
        
    },
}

export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/param.js